import React from 'react';

const TIERS = [
    {
        tone: 'white', who: 'Programme Operator', amount: 'Free',
        per: 'No platform fees*, no revenue share where Accelerator adds their cohort',
        items: ['Deal management platform', 'Cohort dashboard & sponsor reporting', 'Application triage for every applicant'],
        note: '* = Additional fees may be charged for partner services',
    },
    {
        tone: 'lite', who: 'Application Triage', amount: 'Free',
        per: 'For every applicant, accepted or not — no commitment required',
        items: ['20-minute structured overview', 'Readiness score before you read the deck', 'Warm handover if not accepted'],
    },
];

const AccProgrammePricingSection = () => (
    <section className="lp-acc-sec lp-acc-sec--lavender">
        <div className="lp-acc-wrap">
            <span className="lp-acc-kicker" data-lp-reveal>Pricing for your firm</span>
            <h2 className="lp-acc-h2" data-lp-reveal data-lp-delay="60">Free for the programme. Always.</h2>

            <div className="lp-acc-pricing is-two">
                {TIERS.map((t, i) => (
                    <div className={`lp-acc-price-card is-${t.tone}`} key={t.who} data-lp-reveal data-lp-delay={i * 90}>
                        <div className="who">{t.who}</div>
                        <div className="amt">{t.amount}</div>
                        <div className="per">{t.per}</div>
                        <ul>{t.items.map(x => <li key={x}>{x}</li>)}</ul>
                        {t.note && <div className="lp-acc-price-note">{t.note}</div>}
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default AccProgrammePricingSection;
